import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddBoilerMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddBoilerMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  boilerupdatedata,
}) {
  const [boilerData, setBoilerData] = useState({
    Head: triggerupdate ? boilerupdatedata?.head : "",
    Description: triggerupdate ? boilerupdatedata?.description : "",
  });

  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");

  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/Boiler/UpdateBoiler`;
      axiosInstance
        .post(url, {
          id: boilerupdatedata.id,
          head: boilerData.Head,
          description: boilerData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          console.log(err);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/Boiler`;
      axiosInstance
        .post(URL, boilerData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          console.error("Error adding boiler data:", error);
          if (error.status === 500) {
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          } else {
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });
          }
          setloading(false);
        });
    }
  }
  return (
    <form className="add-boiler-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Head{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          required
          placeholder="Enter Boiler Head"
          value={boilerData.Head}
          onChange={(e) =>
            setBoilerData({ ...boilerData, Head: e.target.value.replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100) })
          }
          
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>

      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Maximum 400 Characters)"
          value={boilerData.Description}
          onChange={(e) =>
            setBoilerData({ ...boilerData, Description: e.target.value })
          }
          onInput={(e) => (e.target.value = e.target.value.slice(0, 400))}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddBoilerMaster;
